import styled from 'styled-components';
import { screen, spacing, fontSize } from 'theme';
import Badge from 'components/shared/Badge.styled';

export const StyledBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};
`;

export const StyledBadge = styled(Badge)`
  font-weight: 400;
  border-width: 1px;
  gap: ${spacing('xs')};

  @media (max-width: ${screen('md')}) {
    font-size: ${fontSize('xs2')};
  }
`;

export const Popover = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  min-width: 120px;
  background: #fff;
  color: #222;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 8px 12px;
  z-index: 3;
  font-size: 0.95rem;
  white-space: nowrap;
`;
